<div class="flex flex-col items-center px-4">
  <div class="w-full max-w-2xl mt-6 lg:w-screen">
    <div
      *ngIf="
        liabilityPaymentStatus === PblLiabilityPaymentStatusEnum.PAID || paymentState === PaymentStateEnum.COMPLETED;
        else failed
      "
    >
      <h3 class="mb-6 text-xl font-bold">Status płatności</h3>
      <div class="flex justify-center">
        <app-success-animation [size]="197" color="#00822F"></app-success-animation>
      </div>
      <div class="mb-10 text-2xl text-center text-primary-600">
        Płatność zakończona sukcesem
      </div>
    </div>

    <ng-template #failed>
      <div class="mb-12">
        <h3 class="mb-6 text-xl font-bold">Status płatności</h3>
        <div class="flex justify-center text-red-600">
          <img class="error-icon" src="assets/img/error.svg" alt="Błąd" />
        </div>
        <div class="my-6 text-2xl text-center text-red-600" *ngIf="paymentState === PaymentStateEnum.FAILED">
          Płatność została odrzucona
        </div>
        <div class="my-6 text-2xl text-center text-red-600" *ngIf="paymentState === PaymentStateEnum.CANCELLED">
          Płatność została anulowana
        </div>
        <div class="flex justify-center">
          <button class="btn" mat-flat-button color="primary" routerLink="../">
            rozpocznij ponownie
          </button>
        </div>
      </div>
    </ng-template>

    <app-value-proposition [highlight]="true"></app-value-proposition>
  </div>
</div>
